import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import Select, { components } from "react-select";
// import bgimage from '../../../../../images/auth/apf_logo_bg.png';
import break_box from '../../../../images/product/break_box.png';

const Feedback = ({ show, onClose }) => {
    // Icon
    const [selectedOption, setSelectedOption] = useState(null);
    const [file, setFile] = React.useState(null)
    const imageInputRef = useRef(null);
    const fileHandler = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
        }
    }
    const options_schedule = [
        { value: "1", label: "Morning" },
        { value: "2", label: "Afternoon" },
        { value: "3", label: "Night" },
    ];
    const RemoveImage = () => {
        setFile(null);
        if (imageInputRef.current) {
            imageInputRef.current.value = '';
        }
    };
    // End Icon
    return (
        <Modal className="modal fade" show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Rating Details</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body mb-4">
                    <div className="row">
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Product Category</label>
                            <label className='text-danger fs-6 font-w500'>Break Box</label>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Date & Day</label>
                            <label className='text-danger fs-6 font-w500'>01-May-2025 (Sunday)</label>
                        </div>
                    </div>
                    <hr className='mt-1'></hr>
                    <div className='row'>
                        <label className='col-lg-6 text-gray-800 font-w500 fs-6 mb-2'>Customer Rating</label>
                        <span className='col-lg-6 text-end'>
                            <span><i class="fa fa-star checked fs-6"></i></span>
                            <span><i class="fa fa-star checked fs-6"></i></span>
                            <span><i class="fa fa-star fs-6"></i></span>
                            <span><i class="fa fa-star fs-6"></i></span>
                            <span><i class="fa fa-star fs-6"></i></span>
                        </span>
                    </div>
                     <div className='row'>
                        <label className='col-lg-6 text-gray-800 font-w500 fs-6 mb-2'>Manager Rating</label>
                        <span className='col-lg-6 text-end'>
                            <span><i class="fa fa-star checked fs-6"></i></span>
                            <span><i class="fa fa-star checked fs-6"></i></span>
                            <span><i class="fa fa-star fs-6"></i></span>
                            <span><i class="fa fa-star fs-6"></i></span>
                            <span><i class="fa fa-star fs-6"></i></span>
                        </span>
                    </div>
                     <div className='row'>
                        <label className='col-lg-6 text-gray-800 font-w500 fs-6 mb-2'>Internal Rating</label>
                        <span className='col-lg-6 text-end'>
                            <span><i class="fa fa-star checked fs-6"></i></span>
                            <span><i class="fa fa-star checked fs-6"></i></span>
                            <span><i class="fa fa-star fs-6"></i></span>
                            <span><i class="fa fa-star fs-6"></i></span>
                            <span><i class="fa fa-star fs-6"></i></span>
                        </span>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default Feedback;